const settingsTabLabels = {
  settings: 'Settings',
  narrator: 'Narrator',
  branching: 'Branching',
};

export default settingsTabLabels;
